<cds-icon
    shape="circle"
    [size]="size"
    [status]="value | operationalStateIconStatus"
    solid
></cds-icon>
